// 按照第三方库、本地模块的顺序导入
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Space, Image } from 'antd-mobile'

// 本地模块导入
import OrderCard from '@/components/OrderCard.tsx'
import { useOrderList } from '@/hook/useOrderList'
import SpinPending from '@/components/SpinPending'
import useRefresh from '@/hook/useRefresh'
import { encodeOrderId } from '@/utils/orderIdEncoder'

// 定义路由
export const Route = createFileRoute('/order/')({
  component: OrderPage,
})

export const SpaceStyle = {
  padding: '1rem 0.5rem',
  '--gap': '1rem',
  paddingBottom: '66px',
  backgroundColor: 'var(--bg-color)',
  minHeight: '100vh',
  marginInline: 'auto',
}
// 定义订单页面组件
function OrderPage() {
  const navigate = useNavigate()
  const {
    data: orderList,
    isLoading: orderListIsLoading,
    refetch: refreshOrderList,
  } = useOrderList()
  useRefresh([refreshOrderList])
  // 拆分选择器以确保引用稳定性
  if (orderList !== undefined && orderList.length === 0) {
    return (
      <Space direction="vertical" block style={SpaceStyle}>
        <Image src="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"></Image>
        <h3 className="text-center text-[16px]">
          还没有订单呢，请进入课程详情页面报名课程
        </h3>
      </Space>
    )
  }
  if (orderListIsLoading) {
    return (
      <Space direction="vertical" block style={SpaceStyle} align="center">
        <SpinPending />
      </Space>
    )
  }
  return (
    <Space direction="vertical" block style={SpaceStyle} align="center">
      {/* 使用 map 方法渲染订单卡片列表 */}
      {orderList &&
        [...orderList].map((order) => (
          <OrderCard
            key={order.id}
            order={order}
            onClick={() =>
              navigate({
                to: '/order/$orderId',
                params: {
                  orderId: encodeOrderId(order.id),
                },
              })
            }
          />
        ))}
    </Space>
  )
}
